import { render, staticRenderFns } from "./productPharmacy.vue?vue&type=template&id=71626ad1&scoped=true"
import script from "./productPharmacy.vue?vue&type=script&lang=js"
export * from "./productPharmacy.vue?vue&type=script&lang=js"
import style0 from "./productPharmacy.vue?vue&type=style&index=0&id=71626ad1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71626ad1",
  null
  
)

export default component.exports